import { FC, memo, HTMLAttributes } from 'react';
import cn from 'classnames';

import { CreditData } from '@Types/Product';
import Price from '@UI/Price';
import IconChevronBottom from '@Icons/IconChevronBottom';
import styles from './CreditTab.module.css';

export interface CreditTabProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  credit: CreditData;
  text: string;
  view?: 'catalog' | 'detail';
}

const CreditTab: FC<CreditTabProps> = (props) => {
  const { credit, text, view = 'detail', className, ...restProps } = props;

  return (
    <div
      {...restProps}
      className={cn(
        styles.container,
        { [styles.viewCatalog]: view === 'catalog', [styles.viewDetail]: view === 'detail' },
        className,
      )}
    >
      {credit.icon && (
        <img
          className={styles.icon}
          src={credit.icon.src}
          alt=''
          width={credit.icon.width}
          height={credit.icon.height}
        />
      )}
      <div className={styles.text}>
        {`${text} `} <Price price={credit.price} className={styles.textBold} />
        <span className={styles.textBold}>{` в мес.`}</span>
        <IconChevronBottom className={styles.arrow} />
      </div>
    </div>
  );
};

export default memo(CreditTab);
